import Vue from 'vue'
import { Howl, Howler } from 'howler';

var sounds_list = [];

var sounds = {

	play: function(name) {
		sounds_list[name].play();
	},

	stop: function(name) {
		sounds_list[name].stop();
	},

	set_sound: function(sound, active) {
		for (var i in sounds_list) {
			sounds_list[i].mute(!active)
		}
	},

	init: function() {
		sounds_list['bell'] = new Howl({
			src: [ require('../assets/sounds/bell.mp3') ],
			format: ['mp3'],
			volume: 0.25
		});
		sounds_list['key'] = new Howl({
			src: [ require('../assets/sounds/key.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
		sounds_list['paper'] = new Howl({
			src: [ require('../assets/sounds/paper.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
		sounds_list['error'] = new Howl({
			src: [ require('../assets/sounds/error.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
		sounds_list['notification'] = new Howl({
			src: [ require('../assets/sounds/notification.mp3') ],
			format: ['mp3'],
			volume: 1
		});
		sounds_list['lose'] = new Howl({
			src: [ require('../assets/sounds/lose.mp3') ],
			format: ['mp3'],
			volume: 0.75
		});
	}
}

export default sounds


// WEBPACK FOOTER //
// ./src/core/Sounds.js